export class HospitalReport {
  onset_date!: string;
  hcp_name!: string;
  hcp_surname!: string;
  organization_name!: string;
  status!: number;
  preview?: string;
  id?: number;
  patient_id?: number;
  version_id?: number;
  document_type?: string;
  orcd_document_id?: string;
  author?: string;
  specialty?: string;
  reason_of_hospitalization?: string;
  organization_id?: string;
  organization_tel?: string;
  organization_email?: string;
  organization_street?: string;
  organization_postal_code?: string;
  organization_city?: string;
  organization_country?: string;
}
